import {Enums, Tables, TablesInsert} from "./supabase.ts";

export interface eRacuniResponse<T> {
    response: {
        "status":"ok"|"error",
        "result": T
    };
}

export type eRacuniListResponse<T> = eRacuniResponse<T[]>;

export type eRacuniWorkOrder = TablesInsert<"workOrder">  & {
    OrderedProducts: Tables<"workOrderOrderedProduct">[];
    Address: Tables<"workOrderDeliveryAddress">;
    UsedMaterials: never,
    WorkingHours: never,
    PurchasedMaterials: never,
    DeliveredMaterials: never,
    documentIdBarCode: string
}

export type eRacuniWorkOrderListResponse = eRacuniListResponse<eRacuniWorkOrder>;


export interface eRacuniWorkOrderParams {
    status?: Enums<"workorderstatus">,
    number?: string,
}

export interface eRacuniWorkingHourParams {
    documentID?: number
    WorkingHours?: eRacuniWorkingHour[],
}

export interface eRacuniWorkerParams {
    status?: string,
}

export interface eRacuniProductParams {
    status?: string,
    type?: string,
}
export interface eRacuniPartnerParams {
    status?: string,
}


export interface eracuniReq <T>  {

"username": string,
    "md5pass": string,
    "token":string,
    "method": string,
    parameters: T
}


export const pick = <T extends Object, K extends keyof T>(obj: T, arr: K[]): Partial<Pick<T,K>> =>
    arr.reduce<Partial<Pick<T,K>>>((acc, record) => (record in obj && (acc[record] = obj[record]), acc), {});


export interface eRacuniProduct {
    documentID: string,
    name: string,
    productCode: string,
    barCode: string,
    description: string,
    status: string,
    unit?: string,
}

export interface eRacuniPartner {
    documentID: string,
    partnerCode: string,
    companyName: string,
    email: string,
    remarks?: string,
    vatID?: string,
    status: string,
Addresses: Omit<Tables<"partnerAddress">[],"partnerID">,
}

export interface eRacuniWorker {
    documentID: string;
    partnerCode: string;
    taxID: string;
    lastName: string;
    firstName: string;
    gender: string;
    maritalStatus: string;
    vatRegistration: string;
    createdTimestamp: string;
    lastUpdateTimestamp: string;
}

export interface eRacuniWorkingHour {
    date: Date;
    hoursSpent: number;
    remarks: string;
    workTaskName: string;
    workerCode: string;
    worker: string;
}
